import { CommonController } from '~/controller/CommonController';
new CommonController();
